import Player from "../Player";
import OtherPlayer from "../OtherPlayer";
import DrawPile from "../DrawPile";
import DiscardPile from "../DiscardPile";
import { useAppSelector } from "../../app/hooks";
import { LayoutGroup } from "motion/react";

import styles from "./GameBoard.module.css";
import GameState from "../GameState";

export default function GameBoard() {
  const player = useAppSelector((state) => state.user.player);
  const game = useAppSelector((state) => state.game.game);

  return (
    <LayoutGroup>
      <div className={styles.gameBoard}>
        <div className={styles.top}>
          {game.players.map((gamer) => {
            return (
              player.id !== gamer.id && (
                <OtherPlayer player={gamer} key={gamer.id} />
              )
            );
          })}
        </div>

        <div className={styles.center}>
          <div className={styles.cardPiles}>
            <DrawPile />
            <DiscardPile />
          </div>
          <GameState />
        </div>

        <div className={styles.bottom}>
          <Player />
        </div>
      </div>
    </LayoutGroup>
  );
}
